module.exports = __webpack_public_path__ + "img/rank-3.132785b8.png";